import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faFacebook, faTumblr, faReddit, faLinkedin, faPinterest } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'



export default class ZooShareMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
  SIZES = {
	facebook : { width : 600, height : 300, color: "#3b5998" },
	twitter  : { width : 600, height : 254, color: "#1da1f2" },
	google   : { width : 515, height : 490, color: "#dc483b" },
	linkedin : { width : 600, height : 473, color: "#0077b5" },
	tumblr : { width : 600, height : 473, color: "#36465d" },
	reddit : { width : 600, height : 473, color: "#ff4500" },
	pinterest : { width : 600, height : 473, color: "#bd081c" },
	email : { width : 600, height : 473, color: "#4fcd2c" },
  }
  popupShareDialog(e) {
	e.preventDefault();
	var link   = e.target;
	var network = link.getAttribute('data-network');
	while (!network) {
		link = link.parentNode;
		if (!link) {
			return;
		}
		network = link.getAttribute('data-network');
	}
	var href    = link.getAttribute('data-href');
	network = link.getAttribute('data-network');
	var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
	window.open(href, '', options + 'height=' + this.SIZES[network].height + ',width=' + this.SIZES[network].width);
  }
  emailinvite() {
	// TODO 
  }
  render() {
	var link = window.location.href;
	var title = encodeURIComponent(this.props.title);
	var url = encodeURIComponent(link);
	var thumb = "/images/logo.png";
	var description = encodeURIComponent("I am working with AI and machine learning. Join me!");
	var combined = encodeURIComponent(this.props.title + ". I am working with AI and machine learning. Join me!");
	var styles = {};
	for (var n in this.SIZES) {
		styles[n] = { color: this.SIZES[n].color};
	}
	
	//http://www.tumblr.com/share/link?url=[URL]&amp;name=[title]&amp;description=[content]
	return (
		<div className={this.props.layout}>
			<a style={styles['facebook']} data-href={"https://www.facebook.com/sharer/sharer.php?u=" + url + "&t=" + title + "&via=Automatic.ai"} onClick={this.popupShareDialog.bind(this)} data-network="facebook" title="Invite your Facebook friends to the party"><FontAwesomeIcon icon={faFacebook} /></a>
			<a style={styles['twitter']} data-href={"https://twitter.com/intent/tweet?url=" + url + "&text=" + combined + "&hashtags=Automatic.ai"} onClick={this.popupShareDialog.bind(this)} data-network="twitter" title="Invite your Twitter followers to the party"><FontAwesomeIcon icon={faTwitter} /></a>
			<a style={styles['email']} onClick={this.emailinvite} className="ZToolTipTop" title="Invite your email friends to the party"><FontAwesomeIcon icon={faEnvelope} /></a>
			<a style={styles['tumblr']} data-href={"https://www.tumblr.com/share/link?url=" + url + "&name=" + title + "&description=" + description} onClick={this.popupShareDialog.bind(this)} data-network="tumblr" title="Share on Tumblr"><FontAwesomeIcon icon={faTumblr} /></a>
			<a style={styles['reddit']} data-href={"https://www.reddit.com/submit?url=" + url + "&title=" + title} onClick={this.popupShareDialog.bind(this)} data-network="reddit" className="ZToolTipTop" title="Invite your Reddit followers to the party"><FontAwesomeIcon icon={faReddit} /></a>
			<a style={styles['linkedin']} data-href={"https://www.linkedin.com/shareArticle?mini=true&url=" + url + "&title=" + title + "&summary=" + description + "&source=17997285"} onClick={this.popupShareDialog.bind(this)} data-network="linkedin" className="ZToolTipTop" title="Invite your LinkedIn colleagues to this page"><FontAwesomeIcon icon={faLinkedin} /></a>
			<a style={styles['pinterest']} data-href={"https://pinterest.com/pin/create/button/?url=" + url + "&description=" + title + "&media=" + thumb} onClick={this.popupShareDialog.bind(this)} data-network="pinterest" title="Share on Pinterest"><FontAwesomeIcon icon={faPinterest} /></a>
		</div>
	)
  }
}




// WEBPACK FOOTER //
// ./src/ZooShareMenu.js